import { render } from "./Saude.vue?vue&type=template&id=7838d64b&scoped=true"
import script from "./Saude.vue?vue&type=script&lang=js"
export * from "./Saude.vue?vue&type=script&lang=js"

import "./Saude.vue?vue&type=style&index=0&id=7838d64b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7838d64b"]])

export default __exports__